(function () {
  'use strict';

  /* Korean sido text is guaranteed present regardless of short/long
     administrative suffix (e.g. "강원" vs "강원특별자치도"), so match by
     substring rather than exact string. sidoEnglish is checked as a
     secondary fallback. Codes verified against this store's live Shopify
     checkout province <select> (KR-11 = Seoul, etc.) — NOT ISO 3166-2. */
  var SIDO_MAP = [
    ['서울', 'KR-11'], ['부산', 'KR-26'], ['대구', 'KR-27'], ['인천', 'KR-28'],
    ['광주', 'KR-29'], ['대전', 'KR-30'], ['울산', 'KR-31'], ['세종', 'KR-50'],
    ['경기', 'KR-41'], ['강원', 'KR-42'],
    ['충청북', 'KR-43'], ['충북', 'KR-43'],
    ['충청남', 'KR-44'], ['충남', 'KR-44'],
    ['전라북', 'KR-45'], ['전북', 'KR-45'],
    ['전라남', 'KR-46'], ['전남', 'KR-46'],
    ['경상북', 'KR-47'], ['경북', 'KR-47'],
    ['경상남', 'KR-48'], ['경남', 'KR-48'],
    ['제주', 'KR-49']
  ];

  var SIDO_EN_MAP = [
    ['seoul', 'KR-11'], ['busan', 'KR-26'], ['daegu', 'KR-27'], ['incheon', 'KR-28'],
    ['gwangju', 'KR-29'], ['daejeon', 'KR-30'], ['ulsan', 'KR-31'], ['sejong', 'KR-50'],
    ['gyeonggi', 'KR-41'], ['gangwon', 'KR-42'],
    ['chungcheongbuk', 'KR-43'], ['chungbuk', 'KR-43'],
    ['chungcheongnam', 'KR-44'], ['chungnam', 'KR-44'],
    ['jeollabuk', 'KR-45'], ['jeonbuk', 'KR-45'],
    ['jeollanam', 'KR-46'], ['jeonnam', 'KR-46'],
    ['gyeongsangbuk', 'KR-47'], ['gyeongbuk', 'KR-47'],
    ['gyeongsangnam', 'KR-48'], ['gyeongnam', 'KR-48'],
    ['jeju', 'KR-49']
  ];

  function mapProvinceCode(data) {
    var sido = data.sido || '';
    for (var i = 0; i < SIDO_MAP.length; i++) {
      if (sido.indexOf(SIDO_MAP[i][0]) !== -1) return SIDO_MAP[i][1];
    }
    var en = (data.sidoEnglish || '').toLowerCase();
    for (var j = 0; j < SIDO_EN_MAP.length; j++) {
      if (en.indexOf(SIDO_EN_MAP[j][0]) !== -1) return SIDO_EN_MAP[j][1];
    }
    return '';
  }

  var STORAGE_KEY = 'dd_kr_address_v1';
  var postcodeScriptPromise = null;

  function loadPostcodeScript() {
    if (window.daum && window.daum.Postcode) return Promise.resolve();
    if (postcodeScriptPromise) return postcodeScriptPromise;
    postcodeScriptPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return postcodeScriptPromise;
  }

  function readSaved() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function writeSaved(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  /* address2 (상세주소 - apt/unit/floor) is labeled optional in the widget UI
     and is never auto-filled by the Daum picker - the shopper has to type it
     themselves, and plenty legitimately leave it blank (standalone houses,
     shoppers who skip it). Requiring it here was the actual bug behind the
     "postal code entry jumps to the wrong 시/도 (e.g. Incheon)" reports:
     zip/address1/province are already correctly resolved from the Daum
     picker at this point, but requiring address2 too made isComplete() (and
     therefore writeSaved()) silently discard that correct data whenever the
     field was empty, which made interceptCheckout() bail out with no saved
     address and no error - the checkout then fell through to Shopify's own
     unrelated IP-based address guess. Only zip/address1/province actually
     come from address resolution and need to be present here. */
  function isComplete(state) {
    return !!(state && state.zip && state.address1 && state.province);
  }

  /* All widget copy is written in the Liquid markup as plain Korean (the
     Daum Postcode API and the address FORMAT itself are Korea-only), with no
     locale branching - so a shopper browsing in English/Japanese still saw
     Korean labels even though the rest of the theme's UI translates. Swap
     the visible strings here based on the page's own language, the same way
     dduddi-product.js does for the product page. */
  var KADDR_I18N = {
    en: {
      title: 'Quick address entry',
      optional: '(optional)',
      zip: 'ZIP code',
      search: 'Find ZIP code',
      addr1: 'Address (street)',
      addr2: 'Apt / unit / floor',
      ready: 'Entered — will auto-fill at checkout',
      error: 'Could not load address search. Please try again.'
    },
    ja: {
      title: '配送先クイック入力',
      optional: '（任意）',
      zip: '郵便番号',
      search: '郵便番号を検索',
      addr1: '住所（道路名住所）',
      addr2: '詳細住所（棟/号室など）',
      ready: '入力完了 — 決済時に自動で入力されます',
      error: '住所検索を読み込めませんでした。もう一度お試しください。'
    }
  };

  function kaddrLocale() {
    var l = (document.documentElement.lang || '').toLowerCase();
    if (l.indexOf('ko') === 0) return 'ko';
    if (l.indexOf('ja') === 0) return 'ja';
    return 'en';
  }

  function localizeWidget(root) {
    var t = KADDR_I18N[kaddrLocale()];
    if (!t) return; /* ko: markup's own Korean text is already correct */

    var titleEl = root.querySelector('.dd-kaddr__summary-title');
    if (titleEl) {
      var optEl = titleEl.querySelector('.dd-kaddr__optional');
      for (var i = 0; i < titleEl.childNodes.length; i++) {
        var n = titleEl.childNodes[i];
        if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = t.title + ' '; break; }
      }
      if (optEl) optEl.textContent = t.optional;
    }

    var zipPlaceholderEl = root.querySelector('[data-dd-kaddr-zip]');
    if (zipPlaceholderEl) zipPlaceholderEl.placeholder = t.zip;
    var searchLabelEl = root.querySelector('[data-dd-kaddr-search]');
    if (searchLabelEl) searchLabelEl.textContent = t.search;
    var addr1PlaceholderEl = root.querySelector('[data-dd-kaddr-addr1]');
    if (addr1PlaceholderEl) addr1PlaceholderEl.placeholder = t.addr1;
    var addr2PlaceholderEl = root.querySelector('[data-dd-kaddr-addr2]');
    if (addr2PlaceholderEl) addr2PlaceholderEl.placeholder = t.addr2;

    /* read live via getAttribute() in updateStatus() below, so updating the
       attribute here is enough - no need to touch statusEl directly */
    root.setAttribute('data-ready-text', t.ready);
    root.setAttribute('data-error-text', t.error);
  }

  function initWidget(root) {
    if (root.getAttribute('data-dd-kaddr-init')) return;
    root.setAttribute('data-dd-kaddr-init', '1');
    localizeWidget(root);
    var searchBtn = root.querySelector('[data-dd-kaddr-search]');
    var zipEl = root.querySelector('[data-dd-kaddr-zip]');
    var addr1El = root.querySelector('[data-dd-kaddr-addr1]');
    var addr2El = root.querySelector('[data-dd-kaddr-addr2]');
    var provinceEl = root.querySelector('[data-dd-kaddr-province]');
    var cityEl = root.querySelector('[data-dd-kaddr-city]');
    var statusEl = root.querySelector('[data-dd-kaddr-status]');
    var modal = root.querySelector('[data-dd-kaddr-modal]');
    var embedEl = root.querySelector('[data-dd-kaddr-embed]');
    var closeBtn = root.querySelector('[data-dd-kaddr-close]');
    if (!searchBtn || !zipEl || !addr1El || !addr2El || !provinceEl || !cityEl || !modal || !embedEl) return;

    function closeModal() {
      modal.hidden = true;
      embedEl.innerHTML = '';
    }

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (evt) {
      if (evt.target === modal) closeModal();
    });

    function currentState() {
      return {
        zip: zipEl.value || '',
        address1: addr1El.value || '',
        address2: addr2El.value || '',
        province: provinceEl.value || '',
        city: cityEl.value || ''
      };
    }

    function updateStatus() {
      var state = currentState();
      var complete = isComplete(state);
      if (statusEl) {
        statusEl.textContent = complete
          ? root.getAttribute('data-ready-text') || ''
          : '';
        statusEl.toggleAttribute('data-ready', complete);
      }
      if (complete) {
        writeSaved(state);
      } else {
        writeSaved(null);
      }
    }

    var saved = readSaved();
    if (saved) {
      zipEl.value = saved.zip || '';
      addr1El.value = saved.address1 || '';
      addr2El.value = saved.address2 || '';
      provinceEl.value = saved.province || '';
      cityEl.value = saved.city || '';
      updateStatus();
    }

    addr2El.addEventListener('input', updateStatus);

    function onAddressComplete(data) {
      var addr = data.roadAddress || data.jibunAddress || data.address || '';
      zipEl.value = data.zonecode || '';
      addr1El.value = addr;
      provinceEl.value = mapProvinceCode(data);
      cityEl.value = data.sigungu || '';
      updateStatus();
      addr2El.focus();
    }

    function openEmbedModal() {
      modal.hidden = false;
      searchBtn.disabled = true;
      loadPostcodeScript()
        .then(function () {
          searchBtn.disabled = false;
          embedEl.innerHTML = '';
          new window.daum.Postcode({
            oncomplete: function (data) {
              onAddressComplete(data);
              closeModal();
            },
            width: '100%',
            height: '100%'
          }).embed(embedEl);

          /* Self-heal a real bug we hit in testing: embed() injects the search
             UI into its iframe via document.write, which can silently leave
             the iframe stuck on about:blank. Detect that and retry once. */
          setTimeout(function () {
            var f = embedEl.querySelector('iframe');
            if (f && f.src === 'about:blank') {
              embedEl.innerHTML = '';
              new window.daum.Postcode({
                oncomplete: function (data) {
                  onAddressComplete(data);
                  closeModal();
                },
                width: '100%',
                height: '100%'
              }).embed(embedEl);
            }
          }, 1200);
        })
        .catch(function () {
          searchBtn.disabled = false;
          closeModal();
          if (statusEl) statusEl.textContent = root.getAttribute('data-error-text') || '';
        });
    }

    /* We deliberately always use the inline embed() modal rather than
       Postcode's .open() popup. .open() depends on the browser trusting the
       click as a real user gesture, which we can't reliably verify (behaves
       differently across browsers, in-app browsers, and automated clicks) and
       fails silently or with a dead-end native alert when blocked, with no
       way for us to detect and recover. embed() has one known failure mode
       (iframe stuck on about:blank) but it's directly inspectable in the DOM,
       so we can detect and self-heal it — see openEmbedModal() above. */
    searchBtn.addEventListener('click', function (evt) {
      /* the button lives inside a <summary>'s <details> now — a click on it
         would otherwise also toggle the details open/closed via the native
         summary click behavior, fighting with our own modal open logic */
      evt.preventDefault();
      evt.stopPropagation();
      openEmbedModal();
    });
  }

  function buildPermalink(cartUrl, cart, address) {
    var parts = cart.items.map(function (item) {
      var seg = item.variant_id + ':' + item.quantity;
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        seg += ':' + item.selling_plan_allocation.selling_plan.id;
      }
      return seg;
    });
    var params = new URLSearchParams();
    params.set('checkout[shipping_address][address1]', address.address1);
    params.set('checkout[shipping_address][address2]', address.address2);
    params.set('checkout[shipping_address][city]', address.city);
    params.set('checkout[shipping_address][province]', address.province);
    params.set('checkout[shipping_address][zip]', address.zip);
    params.set('checkout[shipping_address][country]', 'KR');
    return cartUrl + '/' + parts.join(',') + '?' + params.toString();
  }

  /* The checkout button isn't always a descendant of its <form> in the DOM
     (Dawn associates some of them via the button's `form="..."` attribute
     instead of nesting), so a plain form.querySelector() can miss it -
     match on the .form property, which reflects the real association either
     way. */
  function findCheckoutButton(form) {
    var direct = form.querySelector('[name="checkout"]');
    if (direct) return direct;
    var all = document.querySelectorAll('[name="checkout"]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].form === form) return all[i];
    }
    return null;
  }

  /* Binds directly to the checkout button's click event rather than the
     form's submit event + evt.submitter: submitter isn't reliably populated
     across every mobile browser / in-app webview (KakaoTalk, Instagram, older
     iOS Safari), and when it's missing this silently fell through to a
     normal form submit - which, for a signed-in customer, lands on Shopify's
     regular checkout and pulls their saved DEFAULT address instead of what
     was just entered here. A direct click listener has no such gap.
     Tracked on the button itself (not the form) because Dawn can replace
     just the button/footer markup on a cart re-render while the <form>
     node persists - guarding on the form alone would then skip rebinding to
     the new button and silently stop working. */
  function interceptCheckout(form) {
    var btn = findCheckoutButton(form);
    if (!btn || btn.getAttribute('data-dd-kaddr-bound')) return;
    btn.setAttribute('data-dd-kaddr-bound', '1');

    btn.addEventListener('click', function (evt) {
      var saved = readSaved();
      if (!isComplete(saved)) return;

      evt.preventDefault();
      var cartJsUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
      fetch(cartJsUrl)
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart.items || !cart.items.length) return;
          var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
          window.location.href = buildPermalink(cartUrl, cart, saved);
        })
        .catch(function () {
          if (form.requestSubmit) form.requestSubmit(btn); else form.submit();
        });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-dd-kaddr-widget]').forEach(initWidget);
    var cartForm = document.getElementById('cart');
    if (cartForm) interceptCheckout(cartForm);
    var drawerForm = document.getElementById('CartDrawer-Form');
    if (drawerForm) interceptCheckout(drawerForm);
  }

  /* Start loading the Postcode script immediately (script tag is `defer`, so
     this already runs after the HTML is parsed) rather than waiting for the
     button click — by the time a visitor actually clicks, it's almost always
     ready, which is what lets the click handler call .open() synchronously. */
  if (document.querySelector('[data-dd-kaddr-widget]')) loadPostcodeScript();

  document.addEventListener('DOMContentLoaded', initAll);

  /* The cart drawer's contents get replaced wholesale (innerHTML swap) when
     Dawn re-renders it after an add-to-cart or quantity change, which would
     silently drop our widget's event listeners. Watch for that and re-init. */
  new MutationObserver(function () {
    if (document.querySelector('[data-dd-kaddr-widget]:not([data-dd-kaddr-init])')) initAll();
  }).observe(document.body, { childList: true, subtree: true });
})();
